/*
pages
*/
//root
import { Navigate } from "react-router-dom";
import Root from "../pages/Root/index";
import Login from "../pages/Authentication/Login";
import Logout from "../pages/Authentication/Logout";
import LogoutEx from "pages/Authentication/LogoutEx";
import PrivacyPolicy from "../pages/Authentication/PrivacyPolicy";
import Register from "../pages/Authentication/Register";
import RecoverPassword from "../pages/Authentication/RecoverPassword";
import ChangePassword from "../pages/Authentication/ChangePassword";
import DirectRedirection from "pages/Authentication/DirectRedirection";
import LockScreen from "../pages/Authentication/LockScreen";
import TestElement from "TestElement";

// dashboard
import Dashboard from "../pages/Dashboard/index";
import StarterPage from "../pages/StarterPage/index";
import RegisterByPhone from "pages/Authentication/RegisterByPhone";
import InviteRedirection from "pages/Authentication/InviteRedirection";
import WorkplaceCollection from "pages/Dashboard/Workplace/WorkplaceCollection";
import LogoutTest from "pages/Authentication/LogoutTest";
import WorkplacePostInstancePreview from "pages/Dashboard/Workplace/WorkplacePostInstancePreview";

interface RouteProps {
  path: string;
  component: any;
  exact?: boolean;
}

const publicRoutes: Array<RouteProps> = [
  // { path: "/auth-login", component: <Login /> },
  { path: "/auth-login", component: <Navigate to="/auth-register-phone?login=1" replace /> },
  { path: "/auth-register", component: <Register /> },
  { path: "/auth-register-phone", component: <RegisterByPhone></RegisterByPhone> },
  { path: "/auth-recoverpw", component: <RecoverPassword /> },
  { path: "/auth-changepassword", component: <ChangePassword /> },
  { path: "/auth-lock-screen", component: <LockScreen /> },
  //{ path: "/logout", component: <Logout /> },
  { path: "/logout", component: <LogoutTest /> }, // for test auto logout
  { path: "/logoutex", component: <LogoutEx /> },
  { path: "/policy", component: <PrivacyPolicy /> },
  { path: "/test", component: <TestElement /> },
  { path: "/redirect", component: <DirectRedirection /> },
  { path: "/iv/:ivcode", component: <InviteRedirection /> },
  { path: "/pinstant", component: <WorkplacePostInstancePreview /> },
];

const privateRoutes: Array<RouteProps> = [
  
  { path: "/pages-starter", component: <StarterPage /> },
  { path: "/dashboard", component: <Dashboard /> },
  { path: "/wpcol/:parmPostIdParent/:parmImageId", component: <WorkplaceCollection postIdParent="" selImageId={""} onToggle={() => { }} /> },
  { path: "/", component: <Root /> },
  
];

export { publicRoutes, privateRoutes };

